import { SVGProps } from 'react';

const ThreeDotsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M13.0781 12C13.0781 12.5954 12.5954 13.0781 12 13.0781C11.4046 13.0781 10.9219 12.5954 10.9219 12C10.9219 11.4046 11.4046 10.9219 12 10.9219C12.5954 10.9219 13.0781 11.4046 13.0781 12Z"
        fill="#343330"
        stroke="#525252"
        strokeWidth="0.09375"
      />
      <path
        d="M18.375 13.125C18.9963 13.125 19.5 12.6213 19.5 12C19.5 11.3787 18.9963 10.875 18.375 10.875C17.7537 10.875 17.25 11.3787 17.25 12C17.25 12.6213 17.7537 13.125 18.375 13.125Z"
        fill="#343330"
      />
      <path
        d="M5.625 13.125C6.24632 13.125 6.75 12.6213 6.75 12C6.75 11.3787 6.24632 10.875 5.625 10.875C5.00368 10.875 4.5 11.3787 4.5 12C4.5 12.6213 5.00368 13.125 5.625 13.125Z"
        fill="#343330"
      />
    </svg>
  );
};

export default ThreeDotsIcon;
